/* ============================================================
   iVUE — shared storefront interactions (ported from the Denali PDP prototype)
   Every block is DOM-guarded, so it no-ops on pages that lack the markup.
   Variant/price sync is intentionally NOT here — that is handled by the
   Shopify product form inside main-product (real variants).
   ============================================================ */
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* ---------- Scroll-direction banners: announcement + sticky buy-bar move opposite ---------- */
    (function () {
      var topbar = document.getElementById('ivue-topbar');
      var buybar = document.getElementById('ivue-buybar');
      var hero = document.querySelector('[data-ivue-hero]');
      if (!topbar && !buybar) return;
      /* pages that open on a light section mark it with data-ivue-chrome-light:
         the header renders solid from the start (chrome.css body.chrome-light equivalent) */
      if (topbar && document.querySelector('[data-ivue-chrome-light]')) topbar.classList.add('is-light');
      var lastY = window.scrollY;
      function onScroll() {
        var y = window.scrollY, dy = y - lastY;
        if (topbar) {
          topbar.classList.toggle('is-solid', y > 40);
          if (y < 80) topbar.classList.remove('is-anno-hidden');
          else if (dy > 3) topbar.classList.add('is-anno-hidden');
          else if (dy < -3) topbar.classList.remove('is-anno-hidden');
          /* mirror the announcement-hidden state onto <body> so the support
             section-nav (assets/ivue-support.css) can pin flush under the
             header (76px) vs. under header+anno (112px). */
          document.body.classList.toggle('anno-hidden', topbar.classList.contains('is-anno-hidden'));
        }
        if (buybar) {
          var pastHero = hero ? y > hero.offsetHeight * 0.55 : y > 600;
          if (!pastHero) buybar.classList.remove('is-show');
          else if (dy > 3) buybar.classList.add('is-show');
          else if (dy < -3) buybar.classList.remove('is-show');
        }
        lastY = y;
      }
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    /* ---------- Product gallery + lightbox (stacked desktop / swipe carousel mobile) ---------- */
    (function () {
      var frames = Array.prototype.slice.call(document.querySelectorAll('.ivue-gal-frame'));
      var lightbox = document.getElementById('ivue-lightbox');
      if (!frames.length || !lightbox) return;
      var images = frames.map(function (f) { var i = f.querySelector('img'); return { src: i.getAttribute('src'), alt: i.getAttribute('alt') || '' }; });
      var current = 0;
      function showImage(i) { current = (i + images.length) % images.length; }
      frames.forEach(function (f, i) { f.addEventListener('click', function () { current = i; openLightbox(); }); });

      // mobile carousel dot indicators
      var galStack = document.querySelector('.ivue-gal-stack');
      var galDots = document.getElementById('ivue-gal-dots');
      if (galStack && galDots) {
        frames.forEach(function (_, i) { var d = document.createElement('span'); if (i === 0) d.className = 'on'; galDots.appendChild(d); });
        var dots = Array.prototype.slice.call(galDots.children);
        var tick = false;
        galStack.addEventListener('scroll', function () {
          if (tick) return; tick = true;
          requestAnimationFrame(function () {
            tick = false;
            var mid = galStack.scrollLeft + galStack.clientWidth / 2, active = 0, best = Infinity;
            frames.forEach(function (f, i) { var c = f.offsetLeft + f.offsetWidth / 2, d = Math.abs(c - mid); if (d < best) { best = d; active = i; } });
            dots.forEach(function (d, i) { d.classList.toggle('on', i === active); });
            current = active;
          });
        }, { passive: true });
      }

      var lbImg = document.getElementById('ivue-lb-img');
      var lastFocus = null, ZOOM = 2, baseRect = null, swallowClick = false;
      function openLightbox() {
        lastFocus = document.activeElement;
        lbImg.src = images[current].src; lbImg.alt = images[current].alt;
        lbImg.classList.remove('zoomed'); lbImg.style.transform = '';
        lightbox.classList.add('is-open'); document.body.style.overflow = 'hidden';
        var c = document.getElementById('ivue-lb-close'); if (c) c.focus();
      }
      function closeLightbox() { lightbox.classList.remove('is-open'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
      function lbShow(i) { showImage(i); lbImg.src = images[current].src; lbImg.alt = images[current].alt; lbImg.classList.remove('zoomed'); lbImg.style.transform = ''; }
      var closeBtn = document.getElementById('ivue-lb-close'), prevBtn = document.getElementById('ivue-lb-prev'), nextBtn = document.getElementById('ivue-lb-next');
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (prevBtn) prevBtn.addEventListener('click', function () { lbShow(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { lbShow(current + 1); });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
      var lbStage = lightbox.querySelector('.ivue-lb-stage');
      if (lbStage) lbStage.addEventListener('click', function (e) { if (e.target === lbStage) closeLightbox(); });
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') lbShow(current - 1);
        else if (e.key === 'ArrowRight') lbShow(current + 1);
      });
      function panZoomXY(cx, cy) {
        if (!lbImg.classList.contains('zoomed') || !baseRect) return;
        var fx = Math.min(Math.max((cx - baseRect.left) / baseRect.width, 0), 1);
        var fy = Math.min(Math.max((cy - baseRect.top) / baseRect.height, 0), 1);
        lbImg.style.transformOrigin = (fx * 100) + '% ' + (fy * 100) + '%';
        lbImg.style.transform = 'scale(' + ZOOM + ')';
      }
      lbImg.addEventListener('click', function (e) {
        e.stopPropagation();
        var zoomed = lbImg.classList.toggle('zoomed');
        if (!zoomed) { lbImg.style.transform = ''; baseRect = null; return; }
        baseRect = lbImg.getBoundingClientRect(); panZoomXY(e.clientX, e.clientY);
      });
      lightbox.addEventListener('click', function (e) { if (swallowClick && e.target === lbImg) { e.stopImmediatePropagation(); e.preventDefault(); swallowClick = false; } }, true);
      lbImg.addEventListener('mousemove', function (e) { panZoomXY(e.clientX, e.clientY); });

      // touch: double-tap zoom, drag-pan when zoomed, swipe to change, pinch
      (function () {
        var sx = 0, sy = 0, st = 0, moved = false, lastTap = 0, pinching = false, pinchStart = 0;
        function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
        function zoomAt(cx, cy) { baseRect = lbImg.getBoundingClientRect(); lbImg.classList.add('zoomed'); panZoomXY(cx, cy); }
        function unzoom() { lbImg.classList.remove('zoomed'); lbImg.style.transform = ''; baseRect = null; }
        lbImg.addEventListener('touchstart', function (e) {
          if (e.touches.length === 2) { pinching = true; pinchStart = dist(e.touches); return; }
          var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); moved = false;
        }, { passive: true });
        lbImg.addEventListener('touchmove', function (e) {
          if (pinching && e.touches.length === 2) {
            e.preventDefault();
            var d = dist(e.touches), mx = (e.touches[0].clientX + e.touches[1].clientX) / 2, my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            if (d - pinchStart > 30 && !lbImg.classList.contains('zoomed')) zoomAt(mx, my);
            else if (pinchStart - d > 30 && lbImg.classList.contains('zoomed')) unzoom();
            return;
          }
          var t = e.touches[0]; if (!t) return;
          if (Math.abs(t.clientX - sx) > 8 || Math.abs(t.clientY - sy) > 8) moved = true;
          if (lbImg.classList.contains('zoomed')) { e.preventDefault(); panZoomXY(t.clientX, t.clientY); }
        }, { passive: false });
        lbImg.addEventListener('touchend', function (e) {
          if (pinching) { if (e.touches.length === 0) pinching = false; swallowClick = true; return; }
          swallowClick = true;
          var dt = Date.now() - st, dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (lbImg.classList.contains('zoomed')) { if (!moved && dt < 300) unzoom(); return; }
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { lbShow(dx < 0 ? current + 1 : current - 1); return; }
          if (!moved && dt < 300) { var now = Date.now(); if (now - lastTap < 300) { zoomAt(e.changedTouches[0].clientX, e.changedTouches[0].clientY); lastTap = 0; } else lastTap = now; }
        }, { passive: true });
      })();
    })();

    /* ---------- Mega menu (desktop hover-intent) + mobile drawer ---------- */
    (function () {
      var body = document.body;
      var topbar = document.getElementById('ivue-topbar');
      var items = Array.prototype.slice.call(document.querySelectorAll('.ivue-nav-item[data-menu]'));
      if (!items.length) return;
      var openT = null, closeT = null, currentItem = null;
      function setExpanded(item, v) { var t = item.querySelector('.ivue-nav-trigger'); if (t) t.setAttribute('aria-expanded', v ? 'true' : 'false'); }
      function openItem(item) {
        clearTimeout(closeT);
        if (currentItem && currentItem !== item) { currentItem.classList.remove('is-open'); setExpanded(currentItem, false); }
        currentItem = item; item.classList.add('is-open'); setExpanded(item, true);
        body.classList.add('ivue-menu-open'); if (topbar) topbar.classList.add('is-solid');
      }
      function closeAll() {
        if (currentItem) { currentItem.classList.remove('is-open'); setExpanded(currentItem, false); }
        currentItem = null; body.classList.remove('ivue-menu-open');
        if (topbar && window.scrollY <= 40) topbar.classList.remove('is-solid');
      }
      items.forEach(function (item) {
        var trigger = item.querySelector('.ivue-nav-trigger');
        item.addEventListener('mouseenter', function () { clearTimeout(closeT); openT = setTimeout(function () { openItem(item); }, reduce ? 0 : 70); });
        item.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(closeAll, reduce ? 0 : 170); });
        if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); if (item.classList.contains('is-open')) closeAll(); else openItem(item); });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && currentItem) { var t = currentItem.querySelector('.ivue-nav-trigger'); closeAll(); if (t) t.focus(); } });
      document.addEventListener('click', function (e) { if (currentItem && !e.target.closest('.ivue-nav-item')) closeAll(); });
      window.addEventListener('scroll', function () { if (currentItem) closeAll(); }, { passive: true });

      var drawer = document.getElementById('ivue-drawer');
      var backdrop = document.getElementById('ivue-drawer-backdrop');
      var burger = document.querySelector('.ivue-hamburger');
      var dClose = document.querySelector('.ivue-drawer-close');
      function openDrawer() { body.classList.add('ivue-drawer-open'); body.style.overflow = 'hidden'; if (burger) burger.setAttribute('aria-expanded', 'true'); if (drawer) drawer.setAttribute('aria-hidden', 'false'); if (dClose) dClose.focus(); }
      function closeDrawer() { body.classList.remove('ivue-drawer-open'); body.style.overflow = ''; if (burger) burger.setAttribute('aria-expanded', 'false'); if (drawer) drawer.setAttribute('aria-hidden', 'true'); if (burger) burger.focus(); }
      if (burger) burger.addEventListener('click', openDrawer);
      if (dClose) dClose.addEventListener('click', closeDrawer);
      if (backdrop) backdrop.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && body.classList.contains('ivue-drawer-open')) closeDrawer(); });
      Array.prototype.slice.call(document.querySelectorAll('.ivue-drawer .ivue-acc')).forEach(function (acc) {
        var t = acc.querySelector('.ivue-acc-trigger');
        if (t) t.addEventListener('click', function () { var open = acc.classList.toggle('is-open'); t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      });
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
